import instance from '@/api/instance'
import { iRequestLogin } from '@/types/requests'
import { iUserIdentity } from '@/types/responses'

export const login = (data: iRequestLogin) => instance.post<iUserIdentity>('auth/login', data)
export const loadUser = (token: string) => instance.get<iUserIdentity>('auth/load', { params: { token } })
